import React from 'react';

const CheckInIcon = ({ size = '118px', color = '#fff' }) => {
  return (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 512.000000 512.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M1442 5109 c-46 -14 -109 -80 -122 -129 -7 -27 -10 -179 -8 -463 l3
-422 24 -38 c13 -21 42 -50 64 -65 34 -23 52 -27 107 -27 55 0 73 4 107 27 22
15 51 44 64 65 24 38 24 42 27 351 l3 312 1430 0 1429 0 0 -2160 0 -2160
-1429 0 -1430 0 -3 313 c-3 308 -3 312 -27 350 -13 21 -42 50 -64 65 -34 23
-52 27 -107 27 -55 0 -73 -4 -107 -27 -22 -15 -51 -44 -64 -65 l-24 -38 0
-445 0 -445 24 -38 c13 -21 42 -50 64 -65 l41 -27 1696 0 1696 0 41 27 c22 15
51 44 64 65 l24 38 0 2426 0 2425 -27 41 c-15 22 -44 51 -65 64 l-38 24 -1680
2 c-1042 1 -1692 -2 -1713 -8z'
        />
        <path
          d='M1905 3291 c-97 -25 -167 -127 -150 -220 11 -60 34 -92 143 -203
l105 -108 -860 -2 -859 -3 -41 -27 c-62 -41 -88 -90 -88 -168 0 -78 26 -127
88 -168 l41 -27 859 -3 860 -2 -105 -108 c-109 -111 -132 -143 -143 -203 -14
-74 36 -168 109 -206 51 -26 133 -22 186 9 25 15 170 152 322 305 288 289 318
327 318 403 0 76 -30 114 -318 403 -152 153 -295 289 -317 302 -45 27 -106 38
-150 26z'
        />
      </g>
    </svg>
  );
};

export default CheckInIcon;
